"use client";
import Button from "@/components/primitives/button";
import Icon from "@/components/primitives/icon";
import { Splide, SplideSlide, SplideTrack } from "@splidejs/react-splide";
import "@splidejs/react-splide/css/core";
import styles from "./styles.module.css";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

export default function Slider({ sportsbooks }) {
  return (
    <Splide
      hasTrack={false}
      options={{
        type: "loop",
        arrows: false,
        rewind: true,
        perMove: 1,
        easing: "linear",
        waitForTransition: true,
        autoWidth: true,
        pagination: false,
        gap: "8rem",
        drag: false,
        touchMove: false,
        keyboard: false,
        autoScroll: {
          speed: 1,

          pauseOnHover: false,
        },
      }}
      extensions={{ AutoScroll }}
    >
      <SplideTrack className="">
        {sportsbooks?.length &&
          sportsbooks.map((sportsbook, i) => {
            const logoUrl = sportsbook.attributes.logo.data?.attributes.url;
            const lightLogoUrl =
              sportsbook.attributes.light_logo.data?.attributes.url;
            if (!logoUrl && !lightLogoUrl) {
              return null;
            }
            return (
              <SplideSlide key={i}>
                <div className={styles.sportsbookHeroBox}>
                  <img
                    src={lightLogoUrl ? lightLogoUrl : logoUrl}
                    alt={sportsbook.attributes.title}
                    className={styles.sportsbookHeroLogo}
                  />
                </div>
              </SplideSlide>
            );
          })}
      </SplideTrack>
      <div className="splide__arrows absolute flex gap-2 justify-center items-center -top-[3rem] min-[422px]:-top-[3rem] right-3 pr-3 z-[4]">
        <Button
          variant="circle"
          color="secondary"
          size="sm"
          className={`splide__arrow splide__arrow--prev`}
        >
          <Icon name="arrow-left" className="fill-dark" size="sm"></Icon>
        </Button>
        <Button
          variant="circle"
          color="secondary"
          size="sm"
          className={`splide__arrow splide__arrow--next`}
        >
          <Icon name="arrow-right" className="fill-dark" size="sm"></Icon>
        </Button>
      </div>
    </Splide>
  );
}
